/*
  JAY NICK custom: on metal-specific collection pages (e.g. /collections/white-gold-engagement-rings),
  show each product card's image in that metal. Replaces the old jQuery custom.js.
  Re-runs when the product grid changes (filters, sorting, infinite scroll).
*/
(function () {
  var path = window.location.pathname.toLowerCase();
  if (path.indexOf('/collections/') === -1) return;

  var metal = null;
  [['white-gold', 'white'], ['yellow-gold', 'yellow'], ['rose-gold', 'rose'], ['platinum', 'platinum']]
    .forEach(function (m) { if (path.indexOf(m[0]) !== -1) metal = m[1]; });
  if (!metal) return;

  function applyMetal() {
    var cards = document.querySelectorAll('#product-grid li');
    cards.forEach(function (card) {
      if (card.getAttribute('data-jn-metal') === metal) return;
      var swatches = card.querySelectorAll('color-swatch');
      for (var i = 0; i < swatches.length; i++) {
        var swatch = swatches[i];
        var title = (swatch.getAttribute('title') || '').toLowerCase();
        var src = swatch.getAttribute('data-src');
        if (src && title.indexOf(metal) !== -1) {
          var img = card.querySelector('.card__media img');
          if (img) {
            img.src = src;
            var srcset = swatch.getAttribute('data-srcset');
            if (srcset) { img.srcset = srcset; } else { img.removeAttribute('srcset'); }
          }
          card.setAttribute('data-jn-metal', metal);
          break;
        }
      }
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; applyMetal(); });
  }

  function start() {
    applyMetal();
    var main = document.getElementById('MainContent') || document.body;
    new MutationObserver(queue).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
